'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_ControlPlane(label, title, status, bannerTitle, bannerText, steps, footLeft, footRight, chipTop, chipBottom) {
  this.h2 = null;
  this.h5 = null;
  this.h3 = null;
  this.gZ = null;
  this.gY = null;
  this.h4 = null;
  this.h0 = null;
  this.h1 = null;
  this.jR = null;
  this.jQ = null;
  this.h2 = label;
  this.h5 = title;
  this.h3 = status;
  this.gZ = bannerTitle;
  this.gY = bannerText;
  this.h4 = steps;
  this.h0 = footLeft;
  this.h1 = footRight;
  this.jR = chipTop;
  this.jQ = chipBottom;
}
export { $c_Lio_intela_sites_intelacloud_content_ControlPlane as $c_Lio_intela_sites_intelacloud_content_ControlPlane };
$p = $c_Lio_intela_sites_intelacloud_content_ControlPlane.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_ControlPlane;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_ControlPlane() {
}
export { $h_Lio_intela_sites_intelacloud_content_ControlPlane as $h_Lio_intela_sites_intelacloud_content_ControlPlane };
$h_Lio_intela_sites_intelacloud_content_ControlPlane.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-1325521963), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_ControlPlane)) {
    if ((((((this.h2 === x$0.h2) && (this.h5 === x$0.h5)) && (this.h3 === x$0.h3)) && (this.gZ === x$0.gZ)) && (this.gY === x$0.gY))) {
      var x = this.h4;
      var x$2 = x$0.h4;
      var $x_1 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_1 = false;
    }
    if (((($x_1 && (this.h0 === x$0.h0)) && (this.h1 === x$0.h1)) && (this.jR === x$0.jR))) {
      return (this.jQ === x$0.jQ);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 10;
});
$p.I = (function() {
  return "ControlPlane";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.h2;
      break;
    }
    case 1: {
      return this.h5;
      break;
    }
    case 2: {
      return this.h3;
      break;
    }
    case 3: {
      return this.gZ;
      break;
    }
    case 4: {
      return this.gY;
      break;
    }
    case 5: {
      return this.h4;
      break;
    }
    case 6: {
      return this.h0;
      break;
    }
    case 7: {
      return this.h1;
      break;
    }
    case 8: {
      return this.jR;
      break;
    }
    case 9: {
      return this.jQ;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_ControlPlane(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.br)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_ControlPlane as $isArrayOf_Lio_intela_sites_intelacloud_content_ControlPlane };
var $d_Lio_intela_sites_intelacloud_content_ControlPlane = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_ControlPlane, "io.intela.sites.intelacloud.content.ControlPlane", ({
  br: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_ControlPlane as $d_Lio_intela_sites_intelacloud_content_ControlPlane };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Control-Plane.js.map
